module.exports = __webpack_public_path__ + "static/media/shipped.c98c1a5c.svg";